var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 381,
    viewBox: "0 0 351 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 367,
    rx: 30,
    fill: "url(#paint0_linear_806_15065)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_806_15065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.894 297.364V307.636H96.6308L96 299.682L123.349 255.909H133.666L122.493 274.773L108.886 297.364H143.894ZM136.46 255.909V322.091H123.484V255.909H136.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.645 283.182V294.636C195.645 299.606 195.119 303.894 194.068 307.5C193.017 311.076 191.5 314.015 189.517 316.318C187.565 318.591 185.237 320.273 182.534 321.364C179.83 322.455 176.827 323 173.523 323C170.879 323 168.416 322.667 166.133 322C163.851 321.303 161.793 320.227 159.961 318.773C158.159 317.318 156.597 315.485 155.275 313.273C153.983 311.03 152.992 308.364 152.301 305.273C151.611 302.182 151.265 298.636 151.265 294.636V283.182C151.265 278.212 151.791 273.955 152.842 270.409C153.923 266.833 155.44 263.909 157.393 261.636C159.375 259.364 161.718 257.697 164.421 256.636C167.125 255.545 170.128 255 173.432 255C176.076 255 178.524 255.348 180.776 256.045C183.059 256.712 185.117 257.758 186.949 259.182C188.781 260.606 190.343 262.439 191.635 264.682C192.926 266.894 193.918 269.545 194.608 272.636C195.299 275.697 195.645 279.212 195.645 283.182ZM182.624 296.364V281.409C182.624 279.015 182.489 276.924 182.218 275.136C181.978 273.348 181.602 271.833 181.092 270.591C180.581 269.318 179.95 268.288 179.2 267.5C178.449 266.712 177.593 266.136 176.631 265.773C175.67 265.409 174.604 265.227 173.432 265.227C171.961 265.227 170.654 265.515 169.513 266.091C168.401 266.667 167.455 267.591 166.674 268.864C165.893 270.106 165.292 271.773 164.872 273.864C164.481 275.924 164.286 278.439 164.286 281.409V296.364C164.286 298.758 164.406 300.864 164.647 302.682C164.917 304.5 165.307 306.061 165.818 307.364C166.359 308.636 166.989 309.682 167.71 310.5C168.461 311.288 169.317 311.864 170.279 312.227C171.27 312.591 172.351 312.773 173.523 312.773C174.964 312.773 176.241 312.485 177.352 311.909C178.494 311.303 179.455 310.364 180.236 309.091C181.047 307.788 181.648 306.091 182.038 304C182.428 301.909 182.624 299.364 182.624 296.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 297.364V307.636H203.737L203.106 299.682L230.455 255.909H240.772L229.599 274.773L215.992 297.364H251ZM243.566 255.909V322.091H230.59V255.909H243.566Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_806_15065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.046 134.115C185.519 134.115 194.579 130.357 201.979 122.964C209.379 115.572 213.141 106.503 213.141 96.0576C213.141 85.5949 209.379 76.5436 201.979 69.1509C194.579 61.7581 185.501 58 175.046 58C164.573 58 155.513 61.7581 148.113 69.1509C140.713 76.5436 136.952 85.6125 136.952 96.0576C136.952 106.52 140.713 115.572 148.113 122.964C155.531 130.357 164.591 134.115 175.046 134.115Z",
    fill: "url(#paint1_linear_806_15065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.715 179.513C241.503 176.425 241.062 173.073 240.426 169.526C239.79 165.945 238.96 162.575 237.971 159.487C236.947 156.293 235.551 153.135 233.838 150.118C232.055 146.978 229.953 144.26 227.604 142.002C225.149 139.655 222.129 137.767 218.65 136.391C215.188 135.015 211.338 134.327 207.223 134.327C205.616 134.327 204.044 134.997 201.024 136.956C199.17 138.173 196.998 139.567 194.578 141.102C192.512 142.425 189.704 143.66 186.225 144.772C182.834 145.866 179.407 146.413 176.017 146.413C172.626 146.413 169.199 145.866 165.809 144.772C162.347 143.66 159.539 142.425 157.473 141.102C155.071 139.567 152.898 138.173 151.009 136.938C147.989 134.98 146.434 134.309 144.81 134.309C140.695 134.309 136.862 134.997 133.383 136.374C129.904 137.75 126.901 139.638 124.429 141.984C122.08 144.225 119.978 146.96 118.195 150.1C116.482 153.118 115.086 156.276 114.062 159.469C113.073 162.557 112.243 165.927 111.607 169.509C110.971 173.055 110.547 176.407 110.318 179.495C110.106 182.512 110 185.653 110 188.829C110 197.086 112.631 203.755 117.806 208.678C122.91 213.53 129.692 216 137.904 216H214.076C222.306 216 229.07 213.53 234.174 208.678C239.349 203.755 241.98 197.068 241.98 188.829C242.051 185.67 241.927 182.53 241.715 179.513Z",
    fill: "url(#paint2_linear_806_15065)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_806_15065",
    x: 42,
    y: 205,
    width: 263,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12033 0 0 0 0 0.130697 0 0 0 0 0.185124 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_806_15065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_806_15065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_806_15065",
    x: 56,
    y: 8,
    width: 240,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12033 0 0 0 0 0.130697 0 0 0 0 0.185124 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_806_15065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_806_15065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_806_15065",
    x1: 175.5,
    y1: 0,
    x2: 175.5,
    y2: 367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_806_15065",
    x1: 176,
    y1: 58,
    x2: 176,
    y2: 216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_806_15065",
    x1: 176,
    y1: 58,
    x2: 176,
    y2: 216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F6FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/NoUser.26be3ee4a9b854f5d545a63e7a12dafd.svg";
export { ForwardRef as ReactComponent };